import type { TFileWithMeta } from '@components/Files/UploadProvider/types/TFileWithMeta';

export const getNewJobFileDuration = (file: TFileWithMeta): number =>
  Number(file.meta.extra?.duration ?? file.meta.duration ?? 0);

export const getNewJobFilesSubmitReadiness = (files: TFileWithMeta[]) => {
  const activeFiles = files.filter((f) => f.meta.status !== 'removed');

  const allFilesValid = activeFiles.every(
    (f) =>
      (f.meta.status === 'external' && f.meta.extra?.analysisStatus === 'done') ||
      (f.meta.status === 'done' && (!f.file || f.meta.extra?.analysisStatus === 'done')),
  );

  const allHaveDuration = activeFiles.every(
    (f) => Number.isFinite(getNewJobFileDuration(f)) && getNewJobFileDuration(f) > 0,
  );

  const isReady = activeFiles.length > 0 && allFilesValid && allHaveDuration;

  return { activeFiles, allFilesValid, allHaveDuration, isReady };
};
